<template>
  <div class="translate-box">
    <div class="translate-bar" @click="showPickerPopup">
      <img src="@/assets/svg/translate.svg" class="translate-icon" />
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :title="$t('translate.selectTranslateLan')" :columns="columns" :default-index="defaultIndex" value-key="label"
        @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
const flagStr = `@#12vBeghEAAa*!*!#@&`;

export default {
  name: 'Translate',
  props: {
    type: {
      type: String,
      default: 'global'
    },
  },
  data() {
    return {
      columns: [{
        label: '中文',
        value: 'zh-cn'
      },
      {
        label: 'English',
        value: 'en'
      },
      {
        label: this.$t('translate.showOrigin'),
        value: 'origin'
      }
      ],
      defaultIndex: 2,
      showPicker: false,
    }
  },

  created() {
    let language = this.$store.state.Site.language
    if(this.type === 'single') { 
      let index = this.columns.findIndex(item => item.value === language)
      this.defaultIndex = index
     }
  },

  methods: {

    showPickerPopup() {
      this.showPicker = true
    },

    onConfirm(data) {
      let lang = data.value
      if(this.type === 'single') {
        this.$emit('changeLanguage', lang)
        this.showPicker = false;
        return
      }
      if(lang !== 'origin') {
        this.$i18n.locale = lang;
      }else{
        this.$i18n.locale = navigator.language || 'zh-CN';
      }
      if(this.type === 'global') {
        this.$store.commit("updataLanguage", lang);
      }
      this.showPicker = false;
    },
  }
};
</script>

<style scoped lang="scss">
.translate-box {
  .translate-bar {
    .translate-icon {
      width: 20px;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}
</style>
